module.exports = __webpack_public_path__ + "img/client12.e451b8f1.png";